import React, { useState } from 'react';
import { Select } from 'antd';

const FormSelect = ( { header, placeholder, defaultValue = null, values, setValue, width = 'auto' } ) => {
	const { Option } = Select;
	const [ dropdownValue, setDropdownValue ] = useState( defaultValue );
	
	function onChange( value ) {
		setDropdownValue( value );
	}
	
	function onBlur() {
		setValue( dropdownValue );
	}
	
	return (
		<div className="input-wrapper">
			<h3 className="input-header">{ header }</h3>
			<Select
				showSearch
				/*value={ dropdownValue }*/
				placeholder={"Esimerkiksi Tampere"}
				notFoundContent={"Hakemaasi kaupunkia ei löytynyt"}
				optionFilterProp="children"
				onChange={ onChange }
				onBlur={ onBlur }
				style={{ width, color: "#173456"}}
				size="large"
			>
				{ values.map( ( value, index ) => {
					return <Option value={ value.id } key={ index }>{ value.name_fi }</Option>
				}) }
			</Select>
		</div>
	);
};

export default FormSelect;
